import React from 'react';
import { ArrowRight } from 'lucide-react';
import { FLEET } from '../mock';
import { Button } from './ui/button';

const Fleet = () => {
  return (
    <section id="fleet" className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0d3d5e]">
            Our Fleet
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            A diverse range of refrigerated vehicles ready to handle any
            delivery requirement across Perth and Western Australia.
          </p>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {FLEET.map((f) => (
            <div
              key={f.title}
              className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-shadow duration-300 border border-slate-100"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={f.image}
                  alt={f.title}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold text-[#0d3d5e]">
                  {f.title}
                </h3>
                <p className="mt-2 text-slate-600 text-sm leading-relaxed">
                  {f.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a href="#fleet">
            <Button className="bg-[#0d3d5e] hover:bg-[#0a324e] text-white h-12 px-6 rounded-md">
              View Full Fleet Details <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Fleet;
